export default "__VITE_ASSET__DPwDRBbM__"